export default __webpack_public_path__ + "static/eil-28490e3eae7138f8c9aa234f52bd9ff6.png";